const PLACEHOLDER = /\{\{\s*([\w.]+)\s*\}\}/g;

export const buildRunVariables = (
  base: Record<string, string>
): Record<string, string> => {
  const now = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  const stamp = `${pad(now.getDate())}${pad(now.getMonth() + 1)}${pad(
    now.getHours()
  )}${pad(now.getMinutes())}${pad(now.getSeconds())}`;

  return {
    stamp,
    hoy: now.toISOString().slice(0, 10),
    ahora: now.toISOString(),
    uuid: crypto.randomUUID(),
    ...base,
  };
};

export const interpolate = (
  text: string,
  variables: Record<string, string>
): string =>
  text.replace(PLACEHOLDER, (match, name: string) =>
    variables[name] === undefined ? match : variables[name]
  );

export const missingVariables = (
  text: string,
  variables: Record<string, string>
): string[] => {
  const found = new Set<string>();
  for (const match of text.matchAll(PLACEHOLDER)) {
    if (variables[match[1]] === undefined) found.add(match[1]);
  }
  return [...found];
};

/**
 * Lee un valor de la respuesta por camino con puntos. Acepta índices de array
 * (`visits.0.id`), que es como vienen la visita y la ruta al crearla.
 */
export const readPath = (source: unknown, path: string): unknown => {
  if (!path) return source;

  return path.split('.').reduce<unknown>((value, key) => {
    if (value === null || value === undefined) return undefined;
    if (Array.isArray(value)) return value[Number(key)];
    if (typeof value === 'object') return (value as Record<string, unknown>)[key];
    return undefined;
  }, source);
};

export const stringifyCaptured = (value: unknown): string => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};
